import { v4 as uuidv4 } from 'uuid';

export function Form(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'Form',
		componentId: uuidv4(),
		props: Object.assign(
			{
				entity: '',
				schema: '',
			},
			props,
		),
		childrenComponents,
		blocks,
	};
}
